import policy from './workspaceGovernancePolicy.json';
import { hasAnyPermission } from '../auth/permissions';

export const WORKSPACE_GOVERNANCE_POLICY = policy;

export function getWorkspaceGovernanceSurfacePolicy(surfaceKey) {
  return WORKSPACE_GOVERNANCE_POLICY.surfaces?.[surfaceKey] || null;
}

export function getWorkspaceGovernanceRoutePermissions(surfaceKey) {
  return [...(getWorkspaceGovernanceSurfacePolicy(surfaceKey)?.routePermissions || [])];
}

export function getWorkspaceGovernanceEditPermissions(surfaceKey) {
  return [...(getWorkspaceGovernanceSurfacePolicy(surfaceKey)?.editPermissions || [])];
}

export function getWorkspaceGovernanceSharedEditPermissions(surfaceKey) {
  return [...(getWorkspaceGovernanceSurfacePolicy(surfaceKey)?.sharedEditPermissions || [])];
}

export function getWorkspaceGovernanceTenantDefaultPermissions(surfaceKey) {
  return [...(getWorkspaceGovernanceSurfacePolicy(surfaceKey)?.tenantDefaultPermissions || [])];
}

export function getWorkspaceGovernanceDetailLevel(surfaceKey, permissions = []) {
  const detailLevelByPermission =
    getWorkspaceGovernanceSurfacePolicy(surfaceKey)?.detailLevelByPermission || {};
  const orderedPermissions = Object.keys(detailLevelByPermission);

  if (permissions?.includes?.('*') && orderedPermissions.length) {
    return detailLevelByPermission[orderedPermissions[0]] || 'full';
  }

  const matchedPermission = orderedPermissions.find((permissionKey) =>
    hasAnyPermission(permissions, [permissionKey])
  );

  return matchedPermission ? detailLevelByPermission[matchedPermission] || 'denied' : 'denied';
}

export function canAccessWorkspaceGovernedSurface(surfaceKey, permissions = []) {
  const allowedPermissions = getWorkspaceGovernanceRoutePermissions(surfaceKey);
  if (!allowedPermissions.length) {
    return false;
  }

  return hasAnyPermission(permissions, allowedPermissions);
}
